export default "__VITE_ASSET__B8nM$6DF__"